import {
  loadingToError,
  loadingToSuccess,
  showErrorToast,
  showSuccessToast
} from '@components/Notify/Toast';
import { createAsyncOperationTracker, refreshAffectedList } from '../createAsyncOperationTracker';

const BULK_RESTORE_STATUS_TYPE = 'bulk-restore.status';

export const bulkRestoreTracker = createAsyncOperationTracker({
  prefix: 'bulk-restore',
  loadingMessage: 'Restoring records... You will be notified once it completes',
  pendingTtl: 120000,
  completedTtl: 120000,
  toastDuration: 70000
});

export const isQueuedBulkRestoreResponse = bulkRestoreTracker.isQueuedResponse;
export const getBulkRestoreToastId = bulkRestoreTracker.getToastId;
export const handleQueuedBulkRestoreResponse = bulkRestoreTracker.handleQueuedResponse;
export const completeBulkRestoreOperation = bulkRestoreTracker.completeOperation;

const getMessage = (data) => {
  if (Array.isArray(data?.messages)) return data.messages.join(' ');
  if (typeof data?.messages === 'string' && data.messages.trim()) return data.messages;
  if (typeof data?.error === 'string' && data.error.trim()) return data.error;
  return data?.status === 'failed' ? 'Restore operation failed.' : 'Restore operation completed.';
};

export const bulkRestoreHandlers = {
  [BULK_RESTORE_STATUS_TYPE]: (data) => {
    const operationId = data?.operation_id;
    const context = completeBulkRestoreOperation(operationId);
    const toastId = operationId ? getBulkRestoreToastId(operationId) : null;
    const message = getMessage(data);
    const completeFailure = data?.status === 'failed'
      || (Number(data?.restored_count ?? 0) === 0 && Number(data?.failed_count ?? 0) > 0);

    if (completeFailure) {
      if (toastId) loadingToError(toastId, message);
      else showErrorToast(message);
    } else if (data?.status === 'done') {
      if (toastId) loadingToSuccess(toastId, message);
      else showSuccessToast(message);
    } else {
      return; // ignore non-terminal statuses
    }

    refreshAffectedList(context);
  }
};
